import {Page} from "../../theme/js/library/Page.js";

export default class VideoSlider {

	// construct
	constructor( html_element ){

		this.block  = html_element ;
		this.splide = null ;

		this.mountVideoSlider();
		this.handleThumnailsClick();
		this.handleTAC();
	}

	handleTAC(){

		this.block.classList.add( 'has--youtube-disallowed' );
		this.block.classList.remove( 'is--tac---waiting' );


		// already allowed
		document.addEventListener( 'youtube_loaded', () => {
			// console.log('youtube_loaded');
			this.providerIsAllowed( 'youtube' ) ;
		})

		// validation ?
		document.addEventListener( 'youtube_allowed', () => {
			// console.log('youtube_allowed');
			this.providerIsAllowed( 'youtube' ) ;
		});

		this.block.addEventListener( 'click', (e) => {

			const target = e.target;
			// console.log( target );

			if( target.classList.contains( 'tarteaucitronAllow' ) ){
				let the_click = new Event("click");
				let current_slider = this.block.querySelector( '.splide__slide.is-active .splide__video' ) ;
				current_slider.dispatchEvent( the_click );
			}

		});

	}

	providerIsAllowed( provider = '' ){

		if( provider === '' ){ return ; }

		// remove cookie message
		this.block.classList.remove( 'has--youtube-disallowed' );
		this.block.classList.add( 'has--youtube-allowed' );
	}


	handleThumnailsClick(){

		let slider_thumbnail_lists = this.block.querySelectorAll( '.wp-block-whoblock-video-slider__thumbnail-list' );

		slider_thumbnail_lists.forEach(( elt, index) => {

			let buttons = elt.querySelectorAll( 'button' ) ;

			buttons.forEach(( button, index) => {

				button.addEventListener('click', (e) => {

					// pointer-events & touche-action on nested images !

					let current = e.target ;

					// go to the video slide
					let index = current.getAttribute('data-slide-id');
					this.splide.go( '>' + index );

					// clean & set active thumb
					buttons.forEach(( btn, index) => {
						btn.classList.remove('is--active');
						current.classList.add('is--active');
					} );

				});

			});

		});

	}


	mountVideoSlider(){

		let slider_videos = this.block.querySelectorAll( '.splide--video-slider--videos' );

		slider_videos.forEach(( elt, index) => {

			let VideoSliderOptions = {
				
				perPage    : 1,
				rewind     : true,
				perMove    : 1,
				arrows     : false,
				pagination : false,
				gap        : 40,

				direction: 'ttb',
				heightRatio: 0.5925,

				video: {
					loop : true,
					mute : false,

					// disableOverlayUI : true,

					/*
					// test ?
					playerOptions: {
						youtube: { showinof : 0, modestbranding : 1, rel : 0 }
					},
					*/
				},


			}

			// mont
			let splide = new Splide( elt, VideoSliderOptions );
			splide.mount( window.splide.Extensions );

			this.splide = splide ;

		});


	}


}